import React, { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import TimesheetManagement from './TimesheetManagement';
import TaskBasedTimesheetManagement from './TaskBasedTimesheetManagement';

/**
 * Wrapper component that renders the appropriate timesheet management view
 * based on the company's timesheet mode setting.
 *
 * - useTaskBasedTimesheet = true  -> TaskBasedTimesheetManagement (task-based view)
 * - useTaskBasedTimesheet = false -> TimesheetManagement (standard view)
 */
const TimesheetManagementWrapper = () => {
  const { user, loading } = useContext(UserContext);

  // Show loading state while user context is being fetched
  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center h-64">
            <div className="flex flex-col items-center gap-3">
              <div className="w-8 h-8 border-3 border-brand-500 border-t-transparent rounded-full animate-spin" />
              <span className="text-sm text-slate-500">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render appropriate component based on company setting
  if (user?.useTaskBasedTimesheet) {
    return <TaskBasedTimesheetManagement />;
  }

  return <TimesheetManagement />;
};

export default TimesheetManagementWrapper;
